module.exports = __webpack_public_path__ + "static/media/icon-phone-contact.9d1332f9.svg";